export default {
  'pages.layouts.userLayout.title':
    'Efficiently synchronize production NOSQL and SQL data, supporting initial and incremental synchronization with index monitoring',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: admin',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.password.title': 'Change Admin Password',
  'pages.password.oldPassword': 'Current Password',
  'pages.password.newPassword': 'New Password',
  'pages.password.confirmPassword': 'Confirm Password',
  'pages.password.inputOldPassword': 'Please input current password',
  'pages.password.inputNewPassword': 'Please input new password',
  'pages.password.inputConfirmPassword': 'Please confirm new password',
  'pages.password.passwordMismatch': 'The two passwords do not match',
  'pages.password.passwordTooShort': 'Password must be at least 6 characters',
  'pages.password.success': 'Password changed successfully',
  'pages.password.failure': 'Failed to change password',
  'pages.password.current.error': 'Current password is incorrect',
  'pages.userManage.title': 'User Management',
  'pages.userManage.username': 'Username',
  'pages.userManage.email': 'Email',
  'pages.userManage.currentAccess': 'Current Role',
  'pages.userManage.newAccess': 'New Role',
  'pages.userManage.apply': 'Apply',
  'pages.userManage.cancel': 'Cancel',
  'pages.userManage.loadFailed': 'Failed to load user list',
  'pages.userManage.updateSuccess': 'User roles updated successfully',
  'pages.userManage.updateFailed': 'Failed to update user roles',
  'pages.userManage.status': 'Status',
  'pages.userManage.active': 'Active',
  'pages.userManage.inactive': 'Inactive',
  'pages.userManage.changeStatus': 'Change Status',
  'pages.userManage.actions': 'Actions',
  'pages.userManage.delete': 'Delete',
  'pages.userManage.deleteConfirm': 'Are you sure you want to delete this user?',
  'pages.userManage.yes': 'Yes',
  'pages.userManage.no': 'No',
  'pages.userManage.deleteSuccess': 'User deleted successfully',
  'pages.userManage.deleteFailed': 'Failed to delete user',

  'pages.googleCallback.processing': 'Processing Google login...',
  'pages.googleCallback.success': 'Login Successful',
  'pages.googleCallback.debug': 'Google Login Debug',
  'pages.googleCallback.enterHome': 'Enter Homepage',
  'pages.googleCallback.retry': 'Retry Authentication',
  'pages.googleCallback.returnLogin': 'Return to Login',
  'pages.googleCallback.initializing': 'Initializing...',
  'pages.googleCallback.processingCode': 'Processing Google authorization code...',
  'pages.googleCallback.apiTimeout': 'API request timeout!',
  'pages.googleCallback.noAuthCode': 'No authorization code found, please check URL format',
  'pages.googleCallback.tokenSaved': 'Access token saved, length: ',
  'pages.googleCallback.loginSuccess': 'Google login successful',
  'pages.googleCallback.userStateUpdated': 'User state updated, preparing to redirect...',
  'pages.googleCallback.manualProcessing': 'Manually processing authorization code...',
  'pages.googleCallback.noAuthCodeFound': 'No authorization code found in URL',
  'pages.googleCallback.componentLoaded': 'Component loaded, processing callback...',
  'pages.googleCallback.foundAuthCode': 'Found authorization code: ',
  'pages.googleCallback.loginFailed': 'Login processing failed',

  'pages.dashboard.title': 'Data Sync Dashboard',
  'pages.dashboard.syncStatus': 'Sync Status',
  'pages.dashboard.healthyFlows': 'Healthy Flows',
  'pages.dashboard.currentLatency': 'Current Latency',
  'pages.dashboard.comparedLastWeek': 'Compared to Last Week',
  'pages.dashboard.rowsSyncedToday': 'Rows Synced Today',
  'pages.dashboard.tableRowCountTrend': 'Table Row Count Trend',
  'pages.dashboard.showSource': 'Show Source',
  'pages.dashboard.showTarget': 'Show Target',
  'pages.dashboard.showDiff': 'Show Diff',
  'pages.dashboard.activeDataFlows': 'Active Data Flows',
  'pages.dashboard.dataFlow': 'Data Flow',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.latency': 'Latency',
  'pages.dashboard.changesCount': 'Changes',
  'pages.dashboard.flowDetails': 'Flow Details',
  'pages.dashboard.mappings': 'Field Mappings',
  'pages.dashboard.transformations': 'Transformations',
  'pages.dashboard.metrics': 'Performance Metrics',
  'pages.dashboard.syncsToday': 'Syncs Today',
  'pages.dashboard.avgLatency': 'Average Latency',
  'pages.dashboard.active': 'Active',
  'pages.dashboard.warning': 'Warning',
  'pages.dashboard.error': 'Error',
  'pages.dashboard.paused': 'Paused',
  'pages.dashboard.lastHour': 'Last Hour',
  'pages.dashboard.last3Hours': 'Last 3 Hours',
  'pages.dashboard.last6Hours': 'Last 6 Hours',
  'pages.dashboard.last12Hours': 'Last 12 Hours',
  'pages.dashboard.lastDay': 'Last Day',
  'pages.dashboard.last2Days': 'Last 2 Days',
  'pages.dashboard.last7Days': 'Last 7 Days',
  'pages.dashboard.custom': 'Custom',
  'pages.dashboard.dataNotice': 'Data Source Notice',
  'pages.dashboard.dataNoticeDetail':
    'Only "Table Row Count Trend" shows real data in this dashboard. Other metrics and data flows are simulated data.',
  'pages.dashboard.mockDataHint': 'Mock data for demonstration only',
  'pages.dashboard.realData': 'Real Data',

  // ChangeStreams related text
  'pages.dashboard.changeStreamsNotice': 'ChangeStreams Status Dashboard',
  'pages.dashboard.changeStreamsNoticeDetail':
    'Real-time data synchronization status from ChangeStreams API. Dashboard displays live sync metrics and stream health information.',
  'pages.dashboard.activeStreams': 'Active Streams',
  'pages.dashboard.processingRate': 'Processing Rate',
  'pages.dashboard.totalExecuted': 'Executed',
  'pages.dashboard.totalReceived': 'Received',
  'pages.dashboard.totalPending': 'Pending',
  'pages.dashboard.totalTasks': '{count} Tasks',
  'pages.dashboard.realTime': 'Real-time',
  'pages.dashboard.lastUpdated': 'Last Updated: {time}',
  'pages.dashboard.noData': 'No data available',
  'pages.dashboard.activeChangeStreams': 'Active ChangeStreams',
  'pages.dashboard.streamName': 'Stream Name',
  'pages.dashboard.received': 'Received',
  'pages.dashboard.executed': 'Executed',
  'pages.dashboard.inserted': 'Inserted',
  'pages.dashboard.updated': 'Updated',
  'pages.dashboard.deleted': 'Deleted',
  'pages.dashboard.totalInserted': 'Inserted',
  'pages.dashboard.totalUpdated': 'Updated',
  'pages.dashboard.totalDeleted': 'Deleted',
  'pages.dashboard.pending': 'Pending',
  'pages.dashboard.errors': 'Errors',
  'pages.dashboard.taskId': 'Task ID',
  'pages.dashboard.processing': 'Processing',
  'pages.dashboard.idle': 'Idle',
  'pages.dashboard.progress': 'Progress',
  'pages.dashboard.details': 'Details',
  'pages.dashboard.executedOfTotal': '{executed} of {total} executed',
  'pages.dashboard.realDataHint': 'Real-time data from ChangeStreams API',
  'pages.dashboard.streamInfo': 'Stream Information',
  'pages.dashboard.streamCount': 'Streams',
  'pages.dashboard.streamDetails': 'Stream Details',

  'pages.settings.auth.title': 'Authentication Settings',
  'pages.settings.auth.enableOAuth': 'Enable {provider} Account Login',
  'pages.settings.auth.uploadConfig': 'Upload {provider} OAuth Configuration File',
  'pages.settings.auth.configFileHint':
    'Please upload the OAuth client JSON configuration file from {provider}',
  'pages.settings.auth.selectFile': 'Select File',
  'pages.settings.auth.jsonFileOnly': 'You can only upload JSON files!',
  'pages.settings.auth.fileSizeLimit': 'File must be smaller than 2MB!',
  'pages.settings.auth.loading': 'Loading settings...',
  'pages.settings.auth.save': 'Save Settings',
  'pages.settings.auth.saveSuccess': 'Settings saved successfully',
  'pages.settings.auth.saveFailed': 'Failed to save settings',
  'pages.settings.auth.fetchFailed': 'Failed to fetch settings',
  'pages.settings.auth.configHelp.title': 'Configuration Help',
  'pages.settings.auth.configHelp.description':
    'You need to create an OAuth client ID in {provider} and download the JSON configuration file. Make sure you have set the correct redirect URI for your application callback.',
  'pages.settings.auth.configHelp.hint':
    'New OAuth settings will take effect after system restart.',
  'pages.settings.auth.currentConfig': 'Current Configuration',
  'pages.settings.auth.clientId': 'Client ID: {id}',
  'pages.settings.auth.redirectUri': 'Redirect URI: {uri}',
  'pages.settings.auth.scopes': 'Authorization Scopes: {scopes}',
  'pages.settings.auth.enableGoogleOAuth': 'Enable Google Account Login',
  'pages.settings.auth.fileContentError':
    'Unable to get file content, please select the file again',
  'pages.settings.auth.jsonParseError': 'Failed to parse JSON file, please verify the file format',
  'pages.settings.auth.fileReadError': 'Failed to read file',
  'pages.settings.auth.missingClientId': 'Configuration file is missing client_id field',
  'pages.settings.auth.missingClientSecret': 'Configuration file is missing client_secret field',
  'pages.settings.auth.missingRedirectUri': 'Configuration file is missing redirect_uri field',
  'pages.settings.auth.apiRequestFailed': 'API request failed: {message}',
  'pages.settings.auth.configProcessError':
    'Unknown error occurred while processing configuration file',
  'pages.settings.auth.updateSettingsFailed': 'Failed to update settings',

  'pages.login.oauthLogin': 'Login with {provider}',
  'pages.login.googleLogin': 'Login with Google',
  'pages.settings.auth.uploadGoogleConfig': 'Upload Google OAuth Configuration File',
  'pages.settings.auth.googleConfigFileHint':
    'Please upload the OAuth client JSON configuration file from Google Cloud Console',
  'pages.settings.auth.googleConfigHelp.description':
    'You need to create an OAuth client ID in Google Cloud Console and download the JSON configuration file. Make sure you have set the correct redirect URI for your application callback.',

  'pages.syncSettings.advancedSecurity': 'Advanced Security Options (Field Encryption/Masking)',
  'pages.syncSettings.table': 'Table: ',
  'pages.syncSettings.fieldName': 'Field Name',
  'pages.syncSettings.fieldType': 'Type',
  'pages.syncSettings.fieldStatus': 'Status',
  'pages.syncSettings.operation': 'Operation',
  'pages.syncSettings.status.normal': 'Normal',
  'pages.syncSettings.status.masked': 'Masked',
  'pages.syncSettings.status.encrypted': 'Encrypted',
  'pages.syncSettings.action.mask': 'Mask',
  'pages.syncSettings.action.encrypt': 'Encrypt',
  'pages.syncSettings.action.restore': 'Restore',
  'pages.syncSettings.message.fieldStatusChanged':
    'The status of field {field} in table {table} has been changed to {status}',
  'pages.syncSettings.fetchFieldsFailed': 'Failed to fetch table fields',
  'pages.syncSettings.loadingFields': 'Loading fields...',
  'pages.syncSettings.missingConnectionInfo':
    'Connection information is incomplete, unable to fetch table fields',

  'pages.sync.dateRange': 'Date Range',
  'pages.sync.value': 'Value',
  'pages.sync.addCondition': 'Add Query Field',
  'pages.sync.yesterday': 'Yesterday',
  'pages.sync.daily': 'Daily',
  'pages.sync.weekly': 'Weekly',
  'pages.sync.monthly': 'Monthly',
  'pages.sync.conditionList': 'Condition List',
  'pages.sync.fieldName': 'Field Name',
  'pages.sync.fieldType': 'Field Type',
  'pages.sync.securityOptions': 'Security Options',
  'pages.sync.encrypt': 'Encrypt',
  'pages.sync.mask': 'Mask',
  'pages.sync.restore': 'Restore',
  'pages.sync.tableFieldInfo': 'Table Field Info',
  'pages.sync.advancedSecurity': 'Advanced Security Options',
  'pages.sync.enableAdvancedSecurity': 'Enable Advanced Security',
  'pages.sync.testConnection': 'Test Connection',
  'pages.sync.updateSucesss': 'Update successful',
  'pages.sync.addSucesss': 'Add successful',
  'pages.sync.updateFailed': 'Update failed',
  'pages.sync.addFailed': 'Add failed',
  'pages.sync.selectSourceType': 'Please select a Source Type',
  'pages.sync.completeSourceConn': 'Please complete the source connection information',
  'pages.sync.sourceConnSuccess': 'Source DB connection successful',
  'pages.sync.sourceConnFailed': 'Source DB connection failed',
  'pages.sync.completeTargetConn': 'Please complete the target connection information',
  'pages.sync.targetConnSuccess': 'Target DB connection successful',
  'pages.sync.targetConnFailed': 'Target DB connection failed',
  'pages.sync.testConnError': 'Error testing connection',
  'pages.sync.sourceConnAutoSuccess': 'Source DB connection successful (auto load)',
  'pages.sync.sourceConnAutoFailed': 'Source DB connection failed (auto load)',
  'pages.sync.targetConnAutoSuccess': 'Target DB connection successful (auto load)',
  'pages.sync.targetConnAutoFailed': 'Target DB connection failed (auto load)',
  'pages.sync.availableTables': 'Available Tables',
  'pages.sync.selectedTables': 'Selected',
  'pages.sync.editConfig': 'Edit Data Sync Configuration',
  'pages.sync.addConfig': 'Add Data Sync Configuration',
  'pages.sync.sourceType': 'Source Type',
  'pages.sync.sourceDBConn': 'Source DB Connection',
  'pages.sync.targetDBConn': 'Target DB Connection',
  'pages.sync.tableMapping': 'Table/Collection Mapping',
  'pages.sync.sourceTypeStep': 'Source',
  'pages.sync.sourceDBConnStep': 'Source DB',
  'pages.sync.targetDBConnStep': 'Target DB',
  'pages.sync.tableMappingStep': 'Mapping',
  'pages.sync.taskName': 'Task Name',
  'pages.sync.pleaseEnterTaskName': 'Please enter the task name',
  'pages.sync.pleaseSelectSourceType': 'Please select the source type',
  'pages.sync.host': 'Host',
  'pages.sync.port': 'Port',
  'pages.sync.username': 'Username',
  'pages.sync.password': 'Password',
  'pages.sync.databaseName': 'Database Name',
  'pages.sync.pleaseEnterSourceHost': 'Please enter the source DB host',
  'pages.sync.pleaseEnterSourcePort': 'Please enter the source DB port',
  'pages.sync.pleaseEnterSourceDB': 'Please enter the source DB name',
  'pages.sync.pleaseEnterTargetHost': 'Please enter the target DB host',
  'pages.sync.pleaseEnterTargetPort': 'Please enter the target DB port',
  'pages.sync.pleaseEnterTargetDB': 'Please enter the target DB name',
  'pages.sync.pleaseEnterSourceUsername': 'Please enter source username',
  'pages.sync.pleaseEnterSourcePassword': 'Please enter source password',
  'pages.sync.pleaseEnterTargetUsername': 'Please enter target username',
  'pages.sync.pleaseEnterTargetPassword': 'Please enter target password',
  'pages.sync.securityEnabled': 'Enabled',
  'pages.sync.securityDisabled': 'Disabled',

  'pages.sqlDebug.title': 'SQL Debug Tool',
  'pages.sqlDebug.selectTask': 'Select Sync Task',
  'pages.sqlDebug.templates': 'Templates',
  'pages.sqlDebug.select': 'Query',
  'pages.sqlDebug.insert': 'Insert',
  'pages.sqlDebug.update': 'Update',
  'pages.sqlDebug.delete': 'Delete',
  'pages.sqlDebug.executeSource': 'Execute in Source',
  'pages.sqlDebug.executeTarget': 'Execute in Target',
  'pages.sqlDebug.executeBoth': 'Execute in Both',
  'pages.sqlDebug.sourceResult': 'Source DB Result',
  'pages.sqlDebug.targetResult': 'Target DB Result',
  'pages.sqlDebug.noResult': 'No data yet',
  'pages.sqlDebug.refresh': 'Refresh',
  'pages.sqlDebug.loadTasksFailed': 'Failed to load sync tasks',
  'pages.sqlDebug.selectTaskFirst': 'Please select a sync task first',
  'pages.sqlDebug.enterSqlFirst': 'Please enter SQL first',
  'pages.sqlDebug.sourceQuerySuccess': 'Source query successful',
  'pages.sqlDebug.sourceQueryFailed': 'Source query failed',
  'pages.sqlDebug.sourceQueryError': 'Error in source query',
  'pages.sqlDebug.targetQuerySuccess': 'Target query successful',
  'pages.sqlDebug.targetQueryFailed': 'Target query failed',
  'pages.sqlDebug.targetQueryError': 'Error in target query',
  'pages.sqlDebug.affectedRows': 'Affected Rows',
  'pages.sqlDebug.executionTime': 'Execution Time',
  'pages.sqlDebug.message': 'Message',
  'pages.sqlDebug.source': 'Source',
  'pages.sqlDebug.target': 'Target',
  'pages.sqlDebug.redisNotSupported':
    'Redis data source does not support SQL operations, please use Redis commands',
  'pages.sync.searchTables': 'Search tables',

  // Data Backup Management
  'pages.backup.title': 'Data Backup Management',
  'pages.backup.subtitle': 'Configure and manage Data backups to Google Cloud Storage',
  'pages.backup.jobList.title': 'Data Backup Task Management',
  'pages.backup.jobList.createButton': 'Create Backup Task',
  'pages.backup.jobList.name': 'Name',
  'pages.backup.jobList.lastExecStatus': 'Last Execution Status',
  'pages.backup.jobList.status': 'Status',
  'pages.backup.jobList.description': 'Description',
  'pages.backup.jobList.frequency': 'Frequency',
  'pages.backup.jobList.destination': 'Destination',
  'pages.backup.jobList.lastRun': 'Last Run',
  'pages.backup.jobList.nextRun': 'Next Run',
  'pages.backup.jobList.actions': 'Actions',

  'pages.backup.status.success': 'Success',
  'pages.backup.status.failed': 'Failed',
  'pages.backup.status.running': 'Running',
  'pages.backup.status.notRun': 'Not Run',
  'pages.backup.status.enabled': 'Enabled',
  'pages.backup.status.paused': 'Paused',
  'pages.backup.status.error': 'Error',

  'pages.backup.tooltip.pause': 'Pause',
  'pages.backup.tooltip.enable': 'Enable',
  'pages.backup.tooltip.runNow': 'Run Now',
  'pages.backup.tooltip.history': 'Backup History',
  'pages.backup.tooltip.openGcs': 'Open in GCS',
  'pages.backup.tooltip.edit': 'Edit',
  'pages.backup.tooltip.delete': 'Delete',

  'pages.backup.deleteConfirm.title': 'Are you sure you want to delete this backup task?',
  'pages.backup.deleteConfirm.description': 'This action cannot be undone.',
  'pages.backup.messages.taskDeleted': 'Backup task deleted',
  'pages.backup.messages.taskEnabled': 'Backup task enabled',
  'pages.backup.messages.taskPaused': 'Backup task paused',
  'pages.backup.messages.taskRunning': 'Backup task started running',
  'pages.backup.messages.taskCompleted': 'Backup task completed',
  'pages.backup.messages.taskFailed': 'Failed to run task',
  'pages.backup.messages.taskTimeout': 'Backup task timeout',
  'pages.backup.messages.taskStatusFailed': 'Failed to get task status',
  'pages.backup.messages.taskCreated': 'Backup task created',
  'pages.backup.messages.taskUpdated': 'Backup task updated',
  'pages.backup.messages.noGcsPath': 'GCS path not found for this backup task',
  'pages.backup.messages.invalidGcsPath': 'Invalid GCS path format',

  'pages.backup.modal.createTitle': 'Create Backup Task',
  'pages.backup.modal.editTitle': 'Edit Backup Task',
  'pages.backup.modal.update': 'Update',
  'pages.backup.modal.create': 'Create',
  'pages.backup.modal.cancel': 'Cancel',

  'pages.backup.tabs.basic': 'Basic Information',
  'pages.backup.tabs.dataSelection': 'Data Selection',
  'pages.backup.tabs.destination': 'Target Location',
  'pages.backup.tabs.dataSelectionAndDestination': 'Data Selection & Target Location',

  'pages.backup.form.name': 'Task Name',
  'pages.backup.form.name.required': 'Please enter task name',
  'pages.backup.form.name.placeholder': 'e.g., users-daily-backup',
  'pages.backup.form.dbUrl': 'Database URL',
  'pages.backup.form.dbUrl.required': 'Please enter database URL',
  'pages.backup.form.dbUrl.placeholder': 'e.g., mongodb://localhost:27017',
  'pages.backup.form.username': 'Username',
  'pages.backup.form.username.required': 'Please enter username',
  'pages.backup.form.username.placeholder': 'Database username',
  'pages.backup.form.password': 'Password',
  'pages.backup.form.password.required': 'Please enter password',
  'pages.backup.form.password.placeholder': 'Database password',
  'pages.backup.form.database': 'Database Name',
  'pages.backup.form.database.required': 'Please select database',
  'pages.backup.form.database.placeholder': 'Select database',
  'pages.backup.form.cronExpression': 'Backup Frequency (Cron expression)',
  'pages.backup.form.cronExpression.required': 'Please enter Cron expression',
  'pages.backup.form.cronExpression.placeholder': 'e.g., 0 2 * * *',
  'pages.backup.form.cronExpression.tooltip':
    'Use unix-cron format, e.g., 0 2 * * * means every day at 2:00 AM',
  'pages.backup.form.fileType': 'Backup File Format',
  'pages.backup.form.fileType.required': 'Please select backup file format',
  'pages.backup.form.gcsPath': 'GCS Path',
  'pages.backup.form.gcsPath.required': 'Please enter GCS path',
  'pages.backup.form.gcsPath.placeholder': 'e.g., gs://your-bucket/path/to/backups/',
  'pages.backup.form.gcsPath.tooltip':
    'The Google Cloud Storage location where backup files will be stored',
  'pages.backup.form.fileNamePattern': 'File Name Pattern (Regex)',
  'pages.backup.form.fileNamePattern.required': 'Please enter file name pattern',
  'pages.backup.form.fileNamePattern.placeholder': 'e.g., ^{table}_\\d{4}-\\d{2}-\\d{2}_.*\\.json$',
  'pages.backup.form.fileNamePattern.invalid': 'Invalid regular expression',
  'pages.backup.form.fileNamePattern.tooltip':
    'Regular expression pattern to match backup file names. Hover to see matching examples.',
  'pages.backup.form.retention': 'Retention Days',
  'pages.backup.form.retention.required': 'Please enter retention days',
  'pages.backup.form.retention.tooltip':
    'Backups older than the retention period will be automatically deleted',

  'pages.backup.destination.help': 'Configure Google Cloud Storage settings for backup files',

  'pages.sync.queryBuilder': 'Query Builder',
  'pages.sync.queryBuilderHelp':
    'Use the query builder to filter data by specifying conditions on fields.',
  'pages.sync.addQueryField': 'Add Query Field',
  'pages.sync.selectCollection': 'Select a collection to show fields',
  'pages.backup.dataSelection.collections': 'Collection Selection',
  'pages.backup.dataSelection.collections.help': 'Select collections to backup from the left',
  'pages.backup.dataSelection.collections.name': 'Collection Name',
  'pages.backup.dataSelection.collections.fields': 'Fields',
  'pages.backup.dataSelection.collections.queries': 'Queries',
  'pages.backup.dataSelection.fields': 'Field Selection',
  'pages.backup.dataSelection.fields.help': 'Select fields to backup',
  'pages.backup.dataSelection.selectCollection': 'Select a collection to view fields:',
  'pages.backup.dataSelection.selectFirst': 'Please select collections first',
  'pages.backup.dataSelection.selectToView': 'Please select a collection to view its fields',
  'pages.backup.dataSelection.transfer.available': 'Available Collections',
  'pages.backup.dataSelection.transfer.selected': 'Selected Collections',
  'pages.backup.dataSelection.transfer.search': 'Search collections',
  'pages.backup.dataSelection.transfer.selectAdd': 'Select >',
  'pages.backup.dataSelection.transfer.selectRemove': '< Remove',
  'pages.backup.dataSelection.transfer.notFound': 'No data',
  'pages.backup.dataSelection.actions.selectAll': 'Select All',
  'pages.backup.dataSelection.actions.clear': 'Clear',
  'pages.backup.dataSelection.fields.name': 'Field Name',
  'pages.backup.dataSelection.fields.type': 'Type',

  'pages.backup.jobHistory.title': 'Backup History',
  'pages.backup.jobHistory.subtitle': 'View all backup records for a specific task',
  'pages.backup.jobHistory.backButton': 'Back to Backup Tasks',
  'pages.backup.jobHistory.jobDetails': 'Job Details',
  'pages.backup.jobHistory.statistics': 'Statistics',
  'pages.backup.jobHistory.totalBackups': 'Total Backups',
  'pages.backup.jobHistory.successCount': 'Successful',
  'pages.backup.jobHistory.failedCount': 'Failed',
  'pages.backup.jobHistory.totalSize': 'Total Size',
  'pages.backup.jobHistory.avgDuration': 'Average Duration',
  'pages.backup.jobHistory.filter': 'Filter by Date Range',
  'pages.backup.jobHistory.table.name': 'Backup Name',
  'pages.backup.jobHistory.table.createdAt': 'Creation Time',
  'pages.backup.jobHistory.table.status': 'Status',
  'pages.backup.jobHistory.table.size': 'Size',
  'pages.backup.jobHistory.table.duration': 'Duration',
  'pages.backup.jobHistory.table.actions': 'Actions',
  'pages.backup.jobHistory.action.download': 'Download',
  'pages.backup.jobHistory.action.delete': 'Delete',
  'pages.backup.jobHistory.deleteConfirm.title':
    'Are you sure you want to delete this backup record?',
  'pages.backup.jobHistory.deleteConfirm.description': 'This action cannot be undone.',
  'pages.backup.jobHistory.downloadModal.title': 'Download Backup',
  'pages.backup.jobHistory.downloadModal.confirm': 'Confirm Download',
  'pages.backup.jobHistory.downloadModal.cancel': 'Cancel',
  'pages.backup.jobHistory.downloadModal.size': 'File Size',
  'pages.backup.jobHistory.downloadModal.confirm.message':
    'The download may take some time, do you want to continue?',
  'pages.backup.jobHistory.downloadModal.started': 'Download started: {name}',
  'pages.backup.jobHistory.message.recordDeleted': 'Backup deleted',
  'pages.backup.jobHistory.emptyData': 'No backup records found',
  'pages.backup.jobHistory.fetchError': 'Failed to fetch backup history',
  'pages.backup.jobHistory.failureMessage.connectionFailed': 'Database connection failed',
  'pages.backup.jobHistory.info.database': 'Database',
  'pages.backup.jobHistory.info.tables': 'Tables',
  'pages.backup.jobHistory.info.fileFormat': 'Backup Format',
  'pages.backup.jobHistory.info.frequency': 'Backup Frequency',
  'pages.backup.jobHistory.info.storagePath': 'Storage Location',
  'pages.backup.jobHistory.duration.seconds': '{seconds} sec',
  'pages.backup.jobHistory.duration.minutesSeconds': '{minutes} min {seconds} sec',
  'pages.backup.jobHistory.duration.hoursMinutes': '{hours} hr {minutes} min',

  // JobList search feature
  'pages.backup.jobList.search.placeholder': 'Search keyword',
  'pages.backup.jobList.search.button': 'Search',
  'pages.backup.jobList.search.reset': 'Reset',
  'pages.backup.jobList.refresh': 'Refresh',
  'pages.backup.jobList.columns': 'Columns',
  'pages.backup.jobList.addTask': 'Add new backup task',
  // End of Data Backup Management

  // StepsForm related internationalization
  'pages.backup.form.testConnection': 'Test Connection',
  'pages.backup.messages.connectionInfoRequired':
    'Please complete all database connection information',
  'pages.backup.messages.testingConnection': 'Testing database connection...',
  'pages.backup.messages.connectionSuccess': 'Database connection successful',
  'pages.backup.messages.connectionFailed': 'Database connection failed',
  'pages.backup.messages.selectAtLeastOneTable': 'Please select at least one table',
  'pages.backup.scheduleTimes.daily': 'Daily at {time}',
  'pages.backup.scheduleTimes.weekly': 'Weekly on Sunday at {time}',
  'pages.backup.scheduleTimes.monthly': 'Monthly on 1st at {time}',

  // Steps form navigation
  'pages.backup.steps.previous': 'Previous',
  'pages.backup.steps.next': 'Next',
  'pages.backup.steps.submit': 'Submit',

  // Additional backup messages
  'pages.backup.messages.fetchFailed': 'Failed to fetch backup data',
  'pages.backup.messages.refreshSuccess': 'Data refreshed successfully',
  'pages.backup.messages.refreshFailed': 'Failed to refresh data',
  'pages.backup.messages.pleaseCompleteDBInfo': 'Please complete database connection information',
  'pages.backup.messages.connectionRequiredToProceed':
    'Please test connection successfully before proceeding',
  'pages.backup.messages.notFound': 'Backup task not found',

  // Data source type related
  'pages.backup.form.sourceType': 'Source Type',
  'pages.backup.form.sourceType.required': 'Please select a source type!',
  'pages.backup.form.sourceType.placeholder': 'Select database type',
  'pages.backup.tabs.sourceType': 'Source Type',

  // Form validation and interaction
  'pages.backup.form.host': 'Host',
  'pages.backup.form.host.required': 'Host is required',
  'pages.backup.form.host.placeholder': 'Enter host (e.g., localhost)',
  'pages.backup.form.port': 'Port',
  'pages.backup.form.port.required': 'Port is required',
  'pages.backup.form.port.placeholder': 'Enter port (e.g., 27017)',
  'pages.backup.dataSelection.selectTable.placeholder': 'Select tables/collections',

  // Confirmation dialogs
  'pages.backup.confirm.deleteTitle': 'Confirm Deletion',
  'pages.backup.confirm.deleteContent':
    'Are you sure you want to delete this backup task? This action cannot be undone.',
  'pages.backup.confirm.enableTitle': 'Enable Backup Task',
  'pages.backup.confirm.enableContent':
    'Are you sure you want to enable this backup task? It will start running according to its schedule.',
  'pages.backup.confirm.pauseTitle': 'Pause Backup Task',
  'pages.backup.confirm.pauseContent':
    'Are you sure you want to pause this backup task? It will stop running until you enable it again.',
  'pages.backup.confirm.runNowTitle': 'Run Backup Now',
  'pages.backup.confirm.runNowContent':
    'Are you sure you want to run this backup task immediately? This will start the backup process right now.',
  'pages.backup.confirm.ok': 'OK',
  'pages.backup.confirm.cancel': 'Cancel',

  // Data selection features
  'pages.backup.dataSelection.queryBuilder': 'Query Builder',
  'pages.backup.dataSelection.queryBuilder.help':
    'Use the query builder to filter data by specifying conditions on fields.',
  'pages.backup.dataSelection.queryFields': 'Query Fields',
  'pages.backup.dataSelection.addQueryField': 'Add Query Field',
  'pages.backup.dataSelection.selectTableFirst': 'Please select a collection first',
  'pages.backup.dataSelection.fieldName': 'Field Name',
  'pages.backup.dataSelection.fieldValue': 'Value',

  // Date range options
  'pages.backup.dateRange.yesterday': 'Yesterday',
  'pages.backup.dateRange.last7days': 'Last 7 Days',
  'pages.backup.dateRange.last30days': 'Last 30 Days',
  'pages.backup.dateRange.lastWeek': 'Last Week',
  'pages.backup.dateRange.lastMonth': 'Last Month',
  'pages.backup.dateRange.now': 'Now',
  'pages.backup.dateRange.thisWeek': 'This Week',
  'pages.backup.dateRange.thisMonth': 'This Month',
  'pages.backup.dateRange.daysFromTo': '{start} days ago to {end}',
  'pages.backup.dateRange.weeksFromTo': '{start} weeks ago to {end}',
  'pages.backup.dateRange.monthsFromTo': '{start} months ago to {end}',

  // Query related
  'pages.backup.query.fieldRequired': 'Please enter field name',
  'pages.backup.query.addButton': 'Add',
  'pages.backup.query.conditionList': 'Condition List',
  'pages.backup.query.noConditions': 'No conditions configured',
  'pages.backup.query.invalidDateRange': 'Invalid date range format',
  'pages.backup.common.delete': 'Delete',

  // Sync-related entries
  'pages.sync.customCountQuery': 'Use custom count query',
  'pages.sync.customCountQueryDesc':
    'Configure count query conditions instead of using the default count()',
  'pages.sync.selectTable': 'Select Table',
  'pages.sync.selectTableToConfig': 'Select a table to configure',
  'pages.sync.tableSchema': 'Table Schema',
  'pages.sync.queryConditions': 'Query Conditions',
  'pages.sync.tableOverview': 'Table Overview',
  'pages.sync.enableSecurityFirst': 'Please enable Advanced Security Options first',
  'pages.sync.enableQueryFirst': 'Please enable Custom Count Query first',
  'pages.sync.selectTableFirst': 'Please select a table first',
  'pages.sync.tableName': 'Table Name',
  'pages.sync.securityFields': 'Security Fields',
  'pages.sync.configured': 'Configured',
  'pages.sync.notConfigured': 'Not Configured',
  'pages.sync.actions': 'Actions',
  'pages.sync.configSecurity': 'Configure Security',
  'pages.sync.configQuery': 'Configure Query',
  'pages.sync.noConditions': 'No conditions defined',
  'pages.sync.pleaseSelectTableFirst': 'Please select a table first',
  'pages.sync.fieldRequired': 'Field name is required',
  'pages.sync.customCountQueryEnabled': 'Use Custom Count Query',
  'pages.sync.selectTableLabel': 'Select Table:',
  'pages.sync.tableOverviewTab': 'Overview',
  'pages.sync.tableSchemaTab': 'Schema',
  'pages.sync.queryConditionsTab': 'Query',
  'pages.sync.queryEnabled': 'Enabled',
  'pages.sync.advancedSettings': 'Advanced Settings',
  'pages.sync.syncIndexes': 'Sync Indexes',
  'pages.sync.syncIndexesDesc': 'Synchronize database indexes',
  'pages.sync.monitorDelete': 'Monitor Delete Operations',
  'pages.sync.monitorDeleteDesc':
    'Monitor delete operations in addition to insert and update operations',
  'pages.sync.advancedSettingsTab': 'Advanced',
  'pages.sync.configAdvanced': 'Configure Advanced Settings',
  'pages.sync.ignoreDeleteOpsDesc': 'Skip delete operations during sync',
  'pages.sync.ignoreDeleteOps': 'Ignore Delete Operations',
  'pages.sync.uploadToGcs': 'Upload to Google Cloud Storage',
  'pages.sync.uploadToGcsDesc': 'Upload changestream data to Google Cloud Storage',
  'pages.sync.gcsAddress': 'GCS Address',
  'pages.sync.gcsAddressPlaceholder': 'e.g., gs://bucket-name/path/',
  'pages.sync.tableOverviewDesc': 'View configuration status overview for all selected tables',
  'pages.sync.tableSchemaDesc': 'Configure security options for table fields',
  'pages.sync.queryConditionsDesc': 'Configure custom query conditions for data filtering',
  'pages.sync.advancedSettingsDesc': 'Configure advanced sync options',
  'pages.sync.clickToSelectDoubleClickToEdit': 'Click to select, double-click to configure',
  'pages.dashboard.totalErrors': 'Total Errors',
};
